<template>
  <div class="container mb-5">
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Avg Winners Holding Time</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="avg_winners_holding_time"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="avg_winners_holding_time" triggers="hover">
                    Average holding length of a winning trade
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_avg_winners_holding_time }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Total Winners</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="total_winners"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="total_winners" triggers="hover">
                    Number of winning trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_total_winners }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Most Profitable Setup</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="most_profitable_setup"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="most_profitable_setup" triggers="hover">
                    Display the trading setup that has made the most amount of money
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_most_profitable_setup }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Most Traded Setup</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="most_traded_setup"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="most_traded_setup" triggers="hover">
                    Make the trading setup with the highest count and display
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_most_traded_setup }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Most Profitable Holding Time</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="most_profitable_holding_time"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip
                    target="most_profitable_holding_time"
                    triggers="hover"
                  >
                    This counts how much money was made compared to swing or day trading
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_most_profitable_holding_time }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Most Profitable Trading Day</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="most_profitable_trading_day"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip
                    target="most_profitable_trading_day"
                    triggers="hover"
                  >
                    This looks at which day of the week you typically trade bes
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_most_profitable_trading_day }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average % Winners</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_per_winners"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="average_per_winners" triggers="hover">
                    Taking all the winning trades and finding the average % return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_average_per_winners }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Average Return on Winners</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="average_return_on_winners"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip
                    target="average_return_on_winners"
                    triggers="hover"
                  >
                    Taking all the winning trades and finding the average $$ return
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_average_return_on_winners }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Biggest % Profit</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="biggest_per_profit"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="biggest_per_profit" triggers="hover">
                     Largest % win from all trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_biggest_per_profit }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Win %</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="win_per"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="win_per" triggers="hover">
                    Number of winning trades divided by all trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>{{ get_win_per }} %</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Return on Winners</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="return_on_winners"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="return_on_winners" triggers="hover">
                    Add all the positive returns from the main page
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_return_on_winners }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-card bg-variant="dark" header-tag="header" footer-tag="footer">
            <template #header>
              <b-row>
                <b-col cols="8">
                  <p class="mb-0 text-left">Biggest Profit $</p>
                </b-col>
                <b-col>
                  <p class="h5 mb-2 text-right">
                    <b-icon
                      id="biggest_profit"
                      icon="exclamation-circle-fill"
                    ></b-icon>
                  </p>
                  <b-tooltip target="biggest_profit" triggers="hover">
                    Taking the largest win of all the trades
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <b-card-text>
              <h4>$ {{ get_biggest_profit }}</h4>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "WinningChart",
  props: {
    data: {
      type: Array,
    },
    total_fund: {
      type: Number,
    },
  },
  components: {},
  data() {
    return {
      stock_option_array: [],
    };
  },
  computed: {
    get_avg_winners_holding_time() {
      let close_trade = this.data.filter((item) => {
        return item.is_open == false && item.return > 0;
      });
      let timing = close_trade.map((item) => {
        let timediff = new Date(item.exit_date) - new Date(item.date);
        let time_in_hr = Math.ceil(timediff / (1000 * 60 * 60));
        return time_in_hr;
      });

      let total_time = timing.reduce((acc, currentValue) => {
        return acc + currentValue;
      }, 0);

      let avg_time = total_time / timing.length;

      return avg_time.toFixed(2);
    },
    get_total_winners() {
      let winning_trade = this.data.filter((item) => {
        return item.return > 0;
      });

      if (winning_trade.length > 0) {
        return winning_trade.length;
      } else {
        return 0;
      }
    },
    get_most_profitable_setup() {
      let trade = this.data.reduce((acc, currentValue) => {
        if (currentValue.return > 0) {
          currentValue["tags"]["setup"].forEach((element) => {
            if (!acc[element]) {
              acc[element] = 0;
            }
            acc[element] += 1;
          });
          return acc;
        } else {
          return acc;
        }
      }, Object.create(null));

      let max_setup = Object.entries(trade).sort(
        (prev, next) => prev[1] - next[1]
      );

      if (max_setup.length > 0) {
        return max_setup.pop()[0];
      } else {
        return " ";
      }
    },
    get_most_traded_setup() {
      let trade = this.data.reduce((acc, currentValue) => {
        if (currentValue.return !== "") {
          currentValue["tags"]["setup"].forEach((element) => {
            if (!acc[element]) {
              acc[element] = 0;
            }
            acc[element] += 1;
          });
          return acc;
        } else {
          return acc;
        }
      }, Object.create(null));

      let max_setup = Object.entries(trade).sort(
        (prev, next) => prev[1] - next[1]
      );

      // console.log('max_setup ', max_setup.pop()[0])

      if (max_setup.length > 0) {
        return max_setup.pop()[0];
      } else {
        return " ";
      }
    },
    get_most_profitable_holding_time() {
      let trade = this.data.reduce((acc, currentValue) => {
        if (currentValue.return > 0) {
          if (!acc[currentValue.len]) {
            acc[currentValue.len] = currentValue.return;
          }
          acc[currentValue.len] += currentValue.return;
          return acc;
        } else {
          return acc;
        }
      }, Object.create(null));

      let max_setup = Object.entries(trade).sort(
        (prev, next) => prev[1] - next[1]
      );

      // console.log('max_setup ', trade)

      if (max_setup.length > 0) {
        return max_setup.pop()[0];
      } else {
        return " ";
      }
    },
    get_most_profitable_trading_day() {
      let trade = this.data.reduce((acc, currentValue) => {
        if (currentValue.return > 0) {
          let day = new Date(currentValue.date).getDay();
          if (!acc[day]) {
            acc[day] = currentValue.return;
          }
          acc[day] += currentValue.return;
          return acc;
        } else {
          return acc;
        }
      }, Object.create(null));

      let max_setup = Object.entries(trade).sort(
        (prev, next) => prev[1] - next[1]
      );
      var weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";

      if (max_setup.length > 0) {
        let max_profit_day = max_setup.pop()[0];
        return weekday[max_profit_day];
      } else {
        return " ";
      }
    },
    get_average_per_winners() {
      let accumulative_return_per = 0;
      let total_trade = 0;
      this.data.forEach((ele) => {
        if (!ele["is_open"] && ele["return_per"] > 0) {
          accumulative_return_per += ele["return_per"];
          total_trade += 1;
        }
      });

      if (total_trade === 0) {
        return 0;
      } else {
        let percent = accumulative_return_per / total_trade;
        return percent.toFixed(2);
      }
    },
    get_average_return_on_winners() {
      let accumulative_return_per = 0;
      let total_trade = 0;
      this.data.forEach((ele) => {
        if (!ele["is_open"] && ele["return"] > 0) {
          accumulative_return_per += ele["return"];
          total_trade += 1;
        }
      });

      if (total_trade === 0) {
        return 0;
      } else {
        let percent = accumulative_return_per / total_trade;
        return percent.toFixed(2);
      }
    },
    get_biggest_per_profit() {
      let return_per_filter = this.data.filter((item) => {
        return item.return_per > 0;
      });

      let return_per = return_per_filter.map((item) => {
        return item.return_per;
      });

      console.log("return_per ", return_per);

      if (return_per.length > 0) {
        let max_return = Math.max(...return_per);
        return max_return.toFixed(2);
      } else {
        return 0;
      }
    },
    get_win_per() {
      let win_trade = this.data.filter((item) => {
        return item.return > 0;
      });

      let win_percent = win_trade.length / this.data.length;

      return win_percent.toFixed(2);
    },
    get_return_on_winners() {
      let winner_trade = this.data.filter((item) => {
        return item.return > 0;
      });

      let return_val = winner_trade.map((item) =>{
        return item.return
      })

      let total_return = return_val.reduce((acc, currentValue) => {
        return acc + currentValue;
      }, 0);

      return total_return.toFixed(2);
    },
    get_biggest_profit(){
      let return_filter = this.data.filter((item) => {
        return item.return > 0;
      });

      let return_val = return_filter.map((item) => {
        return item.return;
      });

      if (return_val.length > 0) {
        let max_return = Math.max(...return_val);
        return max_return.toFixed(2);
      } else {
        return 0;
      }

    }
  },
  async mounted() {
    if (this.data.length > 0) {
      console.log(this.data);
    }
    // const s = new dfd.Series([1,2,3,4,5])
    // s.print();
  },
  methods: {
    async calAccReturnData() {
      return true;
    },
  },
};
</script>

<style scoped>
.container {
  color: #f8f8f8;
}
</style>